import buildGroupBy from '../buildGroupBy';

/**
 * The chart definition to fetch some of a chart's series with. Top-N charts
 * are ranked by one metric: when that metric isn't among the series, it's
 * carried along so each request ranks its terms the way the chart does.
 */
const toQueryChartDef = ({
  chartDef,
  series,
}: {
  chartDef: V5ChartDefinition;
  series: V5ChartDefinitionSeries[];
}): V5ChartDefinition => {
  const groupBy = buildGroupBy(chartDef);
  const sortMetricId = groupBy ? groupBy.sortByMetric : undefined;
  const isSortMetricFetched =
    !sortMetricId || series.some((s) => s.metricId === sortMetricId);
  const sortCarrier: V5ChartDefinitionSeries[] = isSortMetricFetched
    ? []
    : [
        {
          id: `${chartDef.id}-sort-${sortMetricId}`,
          metricId: sortMetricId,
          sortByMetricId: true,
        },
      ];

  return { ...chartDef, series: [...series, ...sortCarrier] };
};

export default toQueryChartDef;
